import { render, staticRenderFns } from "./ThgCheckoutSustainableFactorDialog.vue?vue&type=template&id=775df319"
import script from "./ThgCheckoutSustainableFactorDialog.vue?vue&type=script&lang=ts"
export * from "./ThgCheckoutSustainableFactorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports